import { render } from "./ChatEmojisDropdown.vue?vue&type=template&id=7ed01597&scoped=true"
import script from "./ChatEmojisDropdown.vue?vue&type=script&lang=js"
export * from "./ChatEmojisDropdown.vue?vue&type=script&lang=js"

import "./ChatEmojisDropdown.vue?vue&type=style&index=0&id=7ed01597&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ed01597"]])

export default __exports__